/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetAiTutorThumbsDownGated = (typeof GetAiTutorThumbsDownGated)[keyof typeof GetAiTutorThumbsDownGated];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetAiTutorThumbsDownGated = {
  gated: 'gated',
  ungated: 'ungated',
} as const;
